import { useMemo } from 'react';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { graphql } from 'relay-runtime';
import { useFilteredCountryListForAmazonQuery } from './__generated__/useFilteredCountryListForAmazonQuery.graphql';

export interface CountryOption {
    label: string;
    value: string;
}

const targetCountries = [
    'AU',
    'BE',
    'BR',
    'CA',
    'EG',
    'FR',
    'DE',
    'IN',
    'IE',
    'IT',
    'JP',
    'MX',
    'NL',
    'PL',
    'SA',
    'SG',
    'ZA',
    'ES',
    'SE',
    'TR',
    'AE',
    'GB',
    'US'
];

export const useFilteredCountryListForAmazon = (): CountryOption[] => {
    const query = useLazyLoadQuery<useFilteredCountryListForAmazonQuery>(
        graphql`
            query useFilteredCountryListForAmazonQuery {
                countries {
                    name
                    twoLetterISOCode
                }
            }
        `,
        {}
    );

    const filteredList = useMemo(() => {
        return (query.countries ?? [])
            .filter((country) => targetCountries.includes(country.twoLetterISOCode ?? ''))
            .map((country) => ({
                label: country.name!,
                value: country.twoLetterISOCode!
            }));
    }, [query.countries]);

    return filteredList;
};
